import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import * as _ from 'lodash';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationHistoryService {
  private navigationHistory: string[] = [];

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.navigationHistory.unshift(event.urlAfterRedirects);
      });
  }

  public getNavigationHistory(): string[] {
    return this.navigationHistory;
  }

  public getStoreNavRoot(): string {
    return _.find(this.navigationHistory, nav => nav === '/home' || nav === '/stores');
  }
}
